/*
 * Ryan O'Dowd
 * 2025-05-30
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  Linking,
  View,
} from 'react-native';
import React, {
  useRef,
} from 'react';
import Icon from '@react-native-vector-icons/material-design-icons';
import ListItem from '@components/ListItem';
import {
  Swipeable,
} from 'react-native-gesture-handler';
import Text from '@components/common/Text';
import {
  format as dateFnsFormat,
} from 'date-fns';
import getStyles from './styles';
import hooks from '@hooks';
import utilities from '@utils/utilities';

const NotesCard = (props: NotesCardProps) => {
  const i18n = hooks.useI18n();
  const styles = hooks.useStyles(getStyles);

  const whatsNewLastReadVersion = hooks.useTypedSelector((state) => state.whatsNewLastReadVersion);

  const swipeableRef = useRef(null);

  const renderLeftActions = () => {
    return (
      <View style={styles.swipeoutButtonView}>
        <Text style={styles.timestampText}>
          {dateFnsFormat(new Date(new Date(props.release_date).getTime() + (new Date().getTimezoneOffset() * 60 * 1000)), 'MMM d, yyyy', {locale: i18n.dateFnsLocale})}
        </Text>
      </View>
    );
  };

  return (
    <Swipeable
      ref={swipeableRef}
      key={props.app_version}
      renderLeftActions={renderLeftActions}
      onSwipeableWillOpen={() => swipeableRef.current?.close()}
    >
      <ListItem
        onPress={() => Linking.openURL(props.link)}
        disabled={!props.link}
        hasBadge={!utilities.isSecondOlderOrSameAsFirst(whatsNewLastReadVersion, props.app_version)}
      >
        <Text style={styles.cardName}>v{props.app_version}</Text>
        {props.release_notes.split('\n').map((line) => {
          return (
            <View key={line} style={styles.textWrapper}>
              {!!line.trim() && <Icon style={styles.lineItemIcon} name='circle' color={styles.isDarkMode ? styles.colors.primaryExtraLight : styles.colors.primaryExtraDark} />}
              <Text style={styles.cardBodyLine}>{line.trim()}</Text>
            </View>
          );
        })}
      </ListItem>
    </Swipeable>
  );
};

class NotesCardProps {
  app_version: string;
  link: string;
  release_date: string;
  release_notes: string;
};

export default NotesCard;
